<div class="grid-view-main-container">
  <div class="table-container">
    <table class="table" *ngIf="data">
      <thead class="thead-dark sticky-top">
        <th class="column-selector-container" *ngIf="showColumnSelector">
          <div (click)="openColumnOptions($event)">
            <ion-icon name="caret-down-circle-outline" class="table-header-select ion-no-padding"></ion-icon>
          </div>
        </th>
        <th class="column-selector-container px-0 ps-1" *ngIf="multiSelectProperty">
            <div class="px-0">
              <input
                type="checkbox"
                class="align-middle"
                [checked]="isAllSelected()"
                (change)="toggleSelectAllRows($event)"
              >
            </div>
          </th>
        <th *ngIf="shouldShowColumn('contactId')" class="id-column">
          <div class="table-heading">
            <p class="text mb-0">Contact ID</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('firstName')" class="phone-number-column">
          <div class="table-heading">
            <p class="text mb-0">Name</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('phoneNumber')" class="phone-number-column">
          <div class="table-heading">
            <p class="text mb-0">Phone Number</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('dateOfBirth')" class="status-column">
          <div class="table-heading">
            <p class="text mb-0">DOB</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('gender')" class="column-width-130">
          <div class="table-heading">
            <p class="text mb-0">Gender</p>
          </div>
        </th>
        <th *ngIf="shouldShowColumn('document')">
          <div class="table-heading">
            <p class="text mb-0">Documents</p>
          </div>
        </th>
        <th class="options-column">
          <div class="table-heading border-0">
            <p class="text mb-0">Options</p>
          </div>
        </th>
      </thead>
    
      <tbody>
        <tr *ngFor="let guest of data; index as i">
          <td></td>
          <td *ngIf="multiSelectProperty" class="px-0">
            <div class="px-0 ps-1">
              <input
                type="checkbox"
                class="align-middle"
                [checked]="isRowSelected(guest)"
                (change)="toggleSelectRow($event, guest)"
              >
            </div>
          </td>
          <td *ngIf="shouldShowColumn('contactId')" routerLink="/contacts/contact-details/{{guest.contactId}}"><span class="clickable-text">{{ guest.contactId }}</span></td>
          <td *ngIf="shouldShowColumn('firstName')">{{ guest.firstName }}</td>
          <td *ngIf="shouldShowColumn('phoneNumber')">{{ guest.phoneCountryCode }} {{ guest.phoneNumber }}</td>
          <td *ngIf="shouldShowColumn('dateOfBirth')"><span *ngIf="guest.dateOfBirth">{{ guest.dateOfBirth | date }}</span> <span *ngIf="!guest.dateOfBirth">--</span></td>
          <td *ngIf="shouldShowColumn('gender')">{{ guest.gender }}<span *ngIf="!guest.gender">--</span></td>
          <td *ngIf="shouldShowColumn('document')" style="padding: 3px;">
            <div class="grid-docs-cell">
              
              <!-- Display only first 3 documents or all documents based on condition -->
               <ng-container *ngIf="guest.document && guest.document.length">
                <ng-container *ngFor="let doc of guest.document.slice(0, guest.showAllDocs ? guest.document.length : 3)">
                  <div class="doc-container">
                    <p class="clickable-file" (click)="openFileInNewTab(doc.path)">{{ doc.documentCategory }}</p>
                    <button class="delete-btn" (click)="deleteDocument(guest, doc)">x</button>
                  </div>
                </ng-container>
        
                <!-- Show "+n more" if there are more than 3 documents and the full list isn't expanded yet -->
                <div *ngIf="guest.document.length > 3 && !guest.showAllDocs">
                  <p class="more-docs-text clickable-file" (click)="toggleDocuments(guest)">
                    +{{ guest.document.length - 3 }} more
                  </p>
                </div>
               </ng-container>

               <ng-container *ngIf="guest.document === null || guest.document.length === 0">
                <p class="text">No Docs Attached</p>
               </ng-container>
              
      
              <!-- Upload button -->
              <div class="upload-button-container">
                <ion-button class="upload-btn" (click)="openUploadDocPopover($event, guest)">
                  <ion-icon name="cloud-upload-outline"></ion-icon>
                </ion-button>
              </div>
            </div>
          </td>
          <td>
            <div class="options" (click)="openPassengerOptionPopover($event, guest)">
              <ion-icon name="ellipsis-horizontal-outline"></ion-icon>
            </div>
          </td>
        </tr>
        <tr *ngIf="data.length === 0">
          <td colspan="7" class="text-center">
            <p class="my-2">No Results Found!</p>
          </td>
        </tr>
      </tbody>
      
    </table>
  </div>
  
  
  
  <div class="w-100 paginations-container" *ngIf="!hidePaginations">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center">
        <div class="select-container">
          <select name="" id="" class="records-selector" [(ngModel)]="paginationSettings.pageSize" (change)="onPageSizeChange()">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>
        <div class="label-container">
          <p class="label">Showing {{noOfRows}} records of {{paginationSettings.totalCount}}</p>
        </div>
      </div>
  
      <div class="control-btns">
        <div class="buttons-row">
          <!-- Back btn -->
          <ion-button class="control-btn" (click)="onPrevious()" [disabled]="paginationSettings.pageNumber === 1">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-button>
  
          <!-- pages buttons list -->
          <ion-button 
            class="control-btn" 
            *ngFor="let page of visiblePages" 
            (click)="onPageChange(page)" 
            [class.active]="page === paginationSettings.pageNumber">
            {{page}}
          </ion-button>
  
          <!-- Forward btn -->
          <ion-button class="control-btn" (click)="onNext()" [disabled]="paginationSettings.pageNumber === paginationSettings.totalPages">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</div>